
/*
import { Component, OnInit, Input } from '@angular/core';
import { UserService } from '../user.service';
import { User } from '../models/users.model';

import { Router } from '@angular/router';

import { ChartsComponent } from '../charts/charts.component';

*/


import {
  Component,
  OnInit,
  ElementRef,
  ChangeDetectorRef,
  Input
} from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from '../user.service';

import { User } from '../models/users.model';

//import { Chart } from 'chart.js';
// import { ChartsComponent } from '../charts/charts.component';



@Component({
  selector: 'course-progress-pane',
  templateUrl: './course-progress-pane.component.html'
})

/*
interface TeamsScope extends ng.IScope {
  teams: string[]
}
*/
export class CourseProgressPaneComponent implements OnInit {
  /*
	this.fn_load = function () {
		console.log("page load");
	};
	*/

  @Input() page: number;

  user: User;
  accessKey = '';
  secretAccessKey = '';
  labState = {};
  lab2_sec_group = '';

  toggle0 = false;
  toggle1 = false;
  toggle2 = false;
  toggle3 = false;
  toggle4 = false;
  toggle5 = false;
  toggle6 = false;
  toggle7 = false;
  toggle8 = false;
  toggle9 = false;
  toggle10 = false;
  toggle11 = false;
  toggle12 = false;
  toggle13 = false;
  toggle14 = false;
  toggle15 = false;
  toggle16 = false;
  toggle17 = false;

  //constructor(private dataAccessService: app.common.DataAccessService, $http: ng.IHttpService, $scope: TeamsScope, userService: UserService) { }

  /*
	public textBinding:string;
	public dataBinding:number;
	public functionBinding:() => any;

	constructor(private userService: UserService) {

		this.textBinding = '';
		this.dataBinding = 0;
	}

	add():void {
		this.functionBinding();
	}

	*/



constructor(
  private userService: UserService,
  private router: Router,
  private elementRef: ElementRef,
  private changeDetectorRef: ChangeDetectorRef,
) {}

  ngOnInit() {
  }

	aws_op_dashboard() {
		this.router.navigate(['/course/awsop/dashboard']);
	}

}



// WEBPACK FOOTER //
// ./src/app/course-progress-pane/course-progress-pane.component.ts